import { memo } from "react";
import { Skeleton } from "~/components/skeleton";
import { TableRow } from "./table-row";
import { TableCell } from "./table-cell";

// Deterministic so visual regression snapshots stay stable. A prime length
// shifts each row's pattern unless the column count is a multiple of it.
const SKELETON_WIDTHS_REM = [7, 9, 5, 10, 6, 8, 5, 9, 7, 10, 6];

const getSkeletonWidth = (row: number, column: number, columnCount: number) => {
  if (column === 0) {
    return "0rem";
  }

  const width =
    SKELETON_WIDTHS_REM[
      (row * columnCount + column) % SKELETON_WIDTHS_REM.length
    ];

  return `${width}rem`;
};

interface SkeletonColumn {
  id: string;
  getSize: () => number;
}

export const SkeletonRows = memo(
  ({ columns }: { columns: readonly SkeletonColumn[] }) => {
    return (
      <>
        {Array.from({ length: 10 }).map((_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: skeleton rows are positional placeholders
          <TableRow key={i}>
            {columns.map((column, index) => (
              <TableCell
                key={column.id}
                style={{ width: column.getSize() || undefined }}
              >
                <Skeleton
                  className="h-[22px]"
                  style={{ width: getSkeletonWidth(i, index, columns.length) }}
                />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </>
    );
  },
);

SkeletonRows.displayName = "SkeletonRows";
